module.exports = __webpack_public_path__ + "img/community.f77e1184.png";